/**
 * Design system constants for Share Modal
 * Following activity details design system patterns
 */

// Import base constants from activity details
import {
  ACTIVITY_DETAILS_COLORS,
  ACTIVITY_DETAILS_RADIUS,
  ACTIVITY_DETAILS_SPACING,
  ACTIVITY_DETAILS_TYPOGRAPHY,
} from '../activity-details/constants';

export const SHARE_MODAL_COLORS = {
  ...ACTIVITY_DETAILS_COLORS,
  backdrop: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black
  whatsapp: '#25D366',
  facebook: '#1877F2',
  link: ACTIVITY_DETAILS_COLORS.gray6,
};

export const SHARE_MODAL_SPACING = {
  ...ACTIVITY_DETAILS_SPACING,
  modalPadding: 32,
  buttonGap: 16,
  headerMarginBottom: 24,
};

export const SHARE_MODAL_RADIUS = {
  modal: 20,
  button: ACTIVITY_DETAILS_RADIUS.button,
};

export const SHARE_MODAL_TYPOGRAPHY = {
  ...ACTIVITY_DETAILS_TYPOGRAPHY,
  title: {
    size: 24,
    weight: 'bold',
    lineHeight: '32px',
  },
  subtitle: {
    size: 16,
    weight: 'normal',
    lineHeight: '24px',
  },
  buttonLabel: {
    size: 16,
    weight: 'semibold',
    lineHeight: '24px',
  },
};

export const SHARE_MODAL_DIMENSIONS = {
  maxWidth: 480,
  buttonHeight: 56,
  closeButtonSize: 40,
};
